import { spacing } from '@moderneinc/design-system-tokens';
import { Box, Stack } from '@mui/material';
import type { FunctionComponent } from 'react';
import { GLOBAL_NAV_HEIGHT } from '../../../constants/general';
import { GlobalActionButtons } from '../global-action-buttons/global-action-buttons.component';
import { GlobalOrganizationSelector } from '../global-organization-selector/global-organization-selector.component';
import { GlobalSearchInput } from '../global-search-input/global-search-input.component';

export const GlobalNavigationBar: FunctionComponent = () => {
  return (
    <Box
      component="nav"
      aria-label="Global navigation"
      sx={{
        position: 'relative',
        width: '100%',
        height: GLOBAL_NAV_HEIGHT
      }}
    >
      {/* Centered gradient background decoration - sunset/glow effect */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          overflow: 'hidden',
          zIndex: 0,
          pointerEvents: 'none'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '70%',
            transform: 'translate(-50%, -50%)',
            width: '1000px',
            maxWidth: '90%',
            height: GLOBAL_NAV_HEIGHT,
            // Subtle brand glow in light mode only — on dark it reads as a
            // bright haze the mock doesn't have, so drop it there.
            background: (theme) =>
              theme.palette.mode === 'dark'
                ? 'transparent'
                : `radial-gradient(ellipse at center, ${theme.palette.modRed['50']} 0%, ${theme.palette.modRed['50']} 40%, transparent 70%)`,
            filter: 'blur(20px)'
          }}
        />
      </Box>
      {/* Navigation content */}
      <Stack
        direction="row"
        sx={{
          gap: `${spacing.spacing_1}px`,
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          py: 1.5,
          // Inset from the bar edges so the org selector isn't flush left
          // (mock .global-nav padding).
          px: `${spacing.spacing_2_1_2}px`,
          position: 'relative',
          zIndex: 1
        }}
      >
        {/* Left: Organization selector */}
        <GlobalOrganizationSelector />

        {/* Spacer to push right content to the end */}
        <Box sx={{ flex: 1 }} />

        {/* Search */}
        <GlobalSearchInput />

        {/* Action buttons */}
        <GlobalActionButtons />
      </Stack>
    </Box>
  );
};
